import Vue from "vue";
import * as MutationsType from "./mutationsType";

/* eslint-disable no-param-reassign */
export default {
  [MutationsType.SET_PRODUCT](state, payload) {
    state.product = payload;
  },
  [MutationsType.SET_PRODUCTS](state, payload) {
    state.products = payload;
  },
  [MutationsType.ADD_PRODUCT](state, payload) {
    if (state.products) state.products.unshift(payload);
  },
  [MutationsType.UPDATE_PRODUCT](state, payload) {
    let ind = (state.products || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.set(state.products, ind, payload);
  },
  [MutationsType.DELETE_PRODUCT](state, payload) {
    let ind = (state.products || []).findIndex((t) => t.id === payload.id);
    if (ind >= 0) Vue.delete(state.products, ind);
  },
};
